import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.AccessUnitNumber1,
  LocationVarKey.AccessUnitNumber2,
  LocationVarKey.AccessUnitNumber3,
  LocationVarKey.FMSUnitNumberChannel,
  LocationVarKey.FMSUnitNumberChannelSMSMessage
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        Unit Number
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccessUnitNumber1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.AccessUnitNumber2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.AccessUnitNumber3}
        enableSwitchVar={LocationVarKey.AccessUnitNumber3Enabled}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasUnitNumberIntegration, "1")}>
        Delivery Settings
      </SectionHeader>
      <DropdownRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasUnitNumberIntegration, "1")}
        marginTop
        label=" Send Unit Number to:"
        keyName={LocationVarKey.FMSUnitNumberChannel}
        options={[
          {
            label: "SMS",
            value: "SMS"
          },
          {
            label: "Email",
            value: "Email"
          },
          {
            label: "SMS and Email",
            value: "Both"
          }
        ]}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSUnitNumberChannel, "Email") && IS_NOT_EQUAL(LocationVarKey.HasUnitNumberIntegration, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.FMSUnitNumberChannelSMSMessage}
      />
    </>
  );
}
